import React, { useEffect, useRef } from 'react';
import { Dropdown, Table } from 'react-bootstrap';
import './PopOver.scss';

const PopOver = ({ id, className, text, isOpen, onToggle, data }) => {
  const popoverRef = useRef(null);
  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popoverRef.current && !popoverRef.current.contains(event.target)) {
        onToggle(false); // Close the dropdown
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onToggle]);

  return (
    <Dropdown
      ref={popoverRef}
      drop="start"
      show={isOpen}
      id="popover-container"
    >
      <Dropdown.Toggle
        variant="light"
        id={id}
        className={className}
        align="end"
        onClick={(event) => {
          event.stopPropagation();
          onToggle(!isOpen);
        }}
      >
        {text}
      </Dropdown.Toggle>
      <Dropdown.Menu className="dropdown-body">
        <div className="options-block">
          <Table responsive>
            <thead className="table-header">
              <tr>
                <th>Call History</th>
                <th>Call</th>
              </tr>
            </thead>
            <tbody>
              {[
                { label: 'Outgoing', value: data?.outgoing },
                { label: 'Unanswered', value: data?.unanswered_calls },
                { label: 'Rejected', value: data?.rejected_calls },
              ].map((item, index) => (
                <tr key={index}>
                  <td>{item.label}</td>
                  <td>{item.value}</td>
                </tr>
              ))}
            </tbody>
            <tfoot className="table-footer">
              <tr>
                <th className="footer-text">Total Connected</th>
                <th className="footer-text">
                  {data?.total_connected}{' '}
                  <span className="call-duration">{data?.total_duration}</span>
                </th>
              </tr>
            </tfoot>
          </Table>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default PopOver;
